import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { WithManagedFocuser } from '@bingads-webui-react/hoc-with-managed-focuser';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

class RawPillItem extends PureComponent {
  constructor(props) {
    super(props);

    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onSelected = this.onSelected.bind(this);
  }

  onFocusHandler() {
    this.props.focusItemCallback(this.props.index);
  }

  onSelected(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.item.disabled) {
      return;
    }
    this.props.onClick(event);
    this.props.focusThis();
  }

  render() {
    const {
      ariaDescribedby,
      item,
      onClick,
      isSelected,
      className,
      hrefParam,
      focusableRef,
    } = this.props;
    const {
      name,
      ariaDescription,
      labelString,
    } = item;

    return (
      <li
        className={className}
        role="presentation"
      >
        <a
          {...hrefParam}
          role="tab"
          onClick={onClick}
          onKeyDown={event => submitEvent(this.onSelected)(event, event)}
          tabIndex={isSelected ? '0' : '-1'}
          aria-selected={isSelected}
          aria-label={name}
          aria-describedby={ariaDescribedby}
          onFocus={this.onFocusHandler}
          ref={focusableRef}
        >
          {name}
          {labelString &&
          <div className="pill-item-label-container">{labelString}</div>}
        </a>
        <p hidden id={ariaDescribedby}>{ariaDescription || ''}</p>
      </li>
    );
  }
}

RawPillItem.propTypes = {
  ariaDescribedby: PropTypes.string.isRequired,
  item: PropTypes.shape({
    name: PropTypes.string,
    disabled: PropTypes.bool,
    ariaDescription: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  className: PropTypes.string,
  hrefParam: PropTypes.exact({
    href: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  focusItemCallback: PropTypes.func.isRequired,
  focusableRef: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  focusThis: PropTypes.func.isRequired,
};

RawPillItem.defaultProps = {
  className: '',
  onClick: _.noop,
  onSelect: _.noop,
};

export const PillItem = WithManagedFocuser(RawPillItem);

